import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Col, ControlLabel, Icon, Message, Panel, Row, Table, Uploader } from 'rsuite'
import { budgetFormat } from '../../utils/formatterUtil'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { isImageOrPdf, isRequired, isValidators } from '../../utils/ValidatorUtils'
import AppContext from '../../context/AppContext'
import classNames from 'classnames'
import InputForm from '../../components/forms/input/InputForm'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import InformationIncon from '../../components/help/InformationIncon'
import { cloneDeep, isEmpty } from 'lodash-es'
import {
  getDowloadSubProjectFilePath,
  getFinancialReport,
  saveFinancialReport,
} from '../../redux/actions/subProjectFinancialReport'
import { DEFAULT_ERR_MSG, SAVE_FAILED_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import notification from '../../utils/notification'
import { doneLoading, startLoading } from '../../utils/loading'
import SubProjectViewFilesWidget from './SubProjectViewFilesWidget'
import NumberFormat from 'react-number-format'

export default function SummaryPeriodicExpensesWidget({
  schema: _schema,
  period,
  projectCode,
  projectVersionId,
  installmentPlanId,
  disabled,
  formsDisabled,
  projectActivitySchema,
  financialReportId,
  statusOnSave = () => {},
  isNotReportsProgress,
  ...props
}) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { theme } = React.useContext(AppContext)
  const [fileTypeError, setFileTypeError] = useState(false)
  const [finalTotalActivityVal, setFinalTotalActivityVal] = useState(0)
  const [isError, setIsError] = useState()
  const [AttachFiles, setAttachFiles] = useState()
  const [errorPeriod1, setErrorPeriod1] = useState(null)
  const [financialReportIdVal, setFinancialReportIdVal] = useState(financialReportId)
  const [formSchemaIncome, setFormSchemaIncome] = useState()
  const [formSchemaExpenses, setFormSchemaExpenses] = useState()
  const [formSchemaBalance, setFormSchemaBalance] = useState()

  const defaultSupportType = '.jpg, .jpeg, .png, .pdf'
  const defaultMaxFileSize = 5

  useEffect(() => {
    // console.log('financialReportId => ', financialReportId)

    if (projectActivitySchema?.value?.length > 0) {
      const totalVal = projectActivitySchema.value.find((val) => val.id == 'total')

      setFinalTotalActivityVal(totalVal?.total >= 0 ? totalVal.total : 0)
    }

    // console.log('_schema => ', _schema.balance)

    setFormSchema(_schema)

    if (_schema?.income) {
      setFormSchemaIncome(_schema?.income)
    }

    if (_schema?.expenses) {
      setFormSchemaExpenses(_schema?.expenses)
    }

    if (_schema?.balance) {
      // console.log('_schema.balance => ', _schema.balance)
      setFormSchemaBalance(_schema?.balance)
    }

    // formSchema.income
  }, [_schema])

  const rowTotal = (item) => {
    return (
      <>
        <Row style={{ marginTop: 10 }}>
          <Col
            lg={11}
            md={11}
            sm={11}
            xs={11}
            style={{
              textAlign: 'right',
              fontWeight: 'bold',
              padding: 5,
            }}
          >
            <div style={{ marginTop: 16 }}>{item.label}</div>
          </Col>
          <Col lg={11} md={11} sm={11} xs={11} style={{ textAlign: 'right' }}>
            <div
              style={{
                borderStyle: 'solid none none none',
                borderWidth: 1,
              }}
            />
            <div
              style={{
                marginTop: 16,
                borderStyle: 'none none double none',
                // fontWeight: 'bold',
              }}
            >
              <b style={{ color: '#8888f2', marginRight: 10 }}>
                {item.value == '-' ? item.value : budgetFormat(item.value)}
              </b>
            </div>
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}>
            <div style={{ marginTop: 16, fontWeight: 'bold' }}>{item.unit}</div>
          </Col>
          {/* <Col lg={11} md={11} sm={11} xs={11}></Col> */}
        </Row>
      </>
    )
  }

  const rowInputForm = (item, index, inputGroup = null) => {
    // console.log('formsDisabled formsDisabled item => ', item.disabled)

    // console.log('rowInputForm item => ', item.name, item)

    if (formsDisabled) {
      item.disabled = true
    }

    if (period == 1) {
      let ssoBalanceObj = formSchema.period1Panel?.inputs?.find(
        (item) => item.name === 'ssoBalance'
      )
      let withdrawAmtObj = formSchema?.period1Panel?.inputs?.find(
        (item) => item?.name === 'withdrawAmt'
      )

      let ssoBalanceVal = ssoBalanceObj?.value || '0'
      let withdrawAmt = withdrawAmtObj?.value || '0'

      //ถ้าเคยบันทึก 0 บาทมาแล้วจะไม่ทำการ set ค่าให้
      if ((withdrawAmt == '0' || withdrawAmt == '0.00') && !financialReportId) {
        item.value = ssoBalanceVal
      }
    }

    return (
      <>
        <Row>
          <Col lg={11} md={11} sm={11} xs={11} style={{ textAlign: 'right' }}>
            <div style={{ marginTop: 12, marginLeft: 80 }}>
              {item.information && <InformationIncon message={item.information} />}

              <ControlLabel className={classNames(isRequired(item.validators) && 'required')}>
                {item.label}
              </ControlLabel>
            </div>
          </Col>
          <Col lg={11} md={11} sm={11} xs={11} style={{ textAlign: 'right' }}>
            <Controller
              name={item.name}
              control={control}
              defaultValue={item.value || 0}
              // rules={isRequired ? { required: 'กรุณากรอกจำนวนเงิน' } : {}}
              rules={isValidators(item.validators)}
              render={(props) => {
                return (
                  <NumberFormat
                    style={{
                      textAlign: 'right',
                      fontWeight: 'bold',
                      color: !item.disabled ? '#2da888' : '#000000',
                    }}
                    className={classNames('rs-input', errors[item.name] && 'is-error')}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale
                    value={props.value}
                    onValueChange={(value) => {
                      // console.log('value.floatValue => ', value.floatValue)
                      // if (value.floatValue > 0) {
                      // console.log('item.name => ', item.name)
                      props.onChange(value.floatValue)

                      if (item.name == 'bankDeposits') {
                        onChangeBankDeposits(value.floatValue)
                      } else {
                        onValueChangeSetTotal(value.floatValue, item, inputGroup)
                      }
                      // } else {
                      //   props.onChange(0)

                      //   if (item.name == 'bankDeposits') {
                      //     onChangeBankDeposits(0)
                      //   } else {
                      //     onValueChangeSetTotal(0, item, inputGroup)
                      //   }
                      // }
                    }}
                    disabled={item.disabled || false}
                    // disabled={true}
                  />
                )
              }}
            />
            {/* <InputForm
              schema={item}
              disabled={item.disable || false}
              placeholder={item.placeholder || ''}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              hideLabel={true}
              isInputNumber={true}
              inputStyle={{
                textAlign: 'right',
                fontWeight: 'bold',
                color: !item.disable ? '#2da888' : '#000000',
                // backgroundColor: item.highlight ? item.highlight : '',
              }}
              key={index}
            /> */}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}>
            <div style={{ marginTop: 12 }}>{item.unit}</div>
          </Col>
          {/* <Col lg={11} md={11} sm={11} xs={11}></Col> */}
        </Row>
      </>
    )
  }

  const onChangeBankDeposits = (val) => {
    // console.log('onChangeBankDeposits => ', val)

    let inputArrBal = cloneDeep(formSchemaBalance || {})

    // console.log('inputArrBal => ', inputArrBal)

    if (inputArrBal.inputs.length > 0) {
      let ExpTot = inputArrBal.inputs.find((item) => item.name == 'total')
      let Deposits = inputArrBal.inputs.find((item) => item.name == 'bankDeposits')

      // console.log('Deposits => ', Deposits)

      let x = 0
      // if (val && val > 0) {
      x = parseFloat(ExpTot.value) - parseFloat(val || 0)
      // } else {
      //   x = parseFloat(ExpTot.value) - parseFloat(Deposits.value)
      // }
      // console.log('x value => ', x)

      inputArrBal.inputs.map((item) => {
        if (item.name == 'moneyOnhand') {
          console.log('inputArrBal => ', inputArrBal)
          // let x = summ - parseFloat(ExpTot.value) - parseFloat(Deposits.value)
          item.value = x
          setValue('moneyOnhand', x)
        } else if (item.name == 'bankDeposits') {
          item.value = val
        }
      })

      setValue('moneyOnhand', x)
      setFormSchemaBalance(inputArrBal)
    }
  }

  const onValueChangeSetTotal = (val = 0, inputItem, inputGroup) => {
    // console.log('onValueChangeSetTotal => ', val, inputItem.name, inputGroup)

    if (period == 1) {
      // console.log('Cancel onValueChangeSetTotal')
      return false
    }

    if (inputGroup == 'income') {
      let inputArr = cloneDeep(formSchemaIncome || {})
      let inputArrEx = cloneDeep(formSchemaExpenses || {})
      let inputArrBal = cloneDeep(formSchemaBalance || {})

      let summ = 0

      if (inputArr?.inputs?.length > 0) {
        inputArr.inputs.map((item) => {
          if (item.name == inputItem.name) {
            item.value = val
            summ += parseFloat(val)
          } else {
            if (item.name != 'total') {
              summ += parseFloat(item.value)
            }
          }

          // console.log('a => ', summ)

          if (item.name == 'total') {
            item.value = summ
          }
        })
      }

      if (inputArrBal.inputs.length > 0) {
        let ExpTot = inputArrEx.inputs.find((item) => item.name == 'total')
        let Deposits = inputArrBal.inputs.find((item) => item.name == 'bankDeposits')
        // let Onhand = inputArrBal.inputs.find((item) => item.name == 'moneyOnhand')

        inputArrBal.inputs.map((item) => {
          if (item.name == 'total') {
            item.value = summ - parseFloat(ExpTot.value)
          } else if (item.name == 'moneyOnhand') {
            // console.log('inputArrBal => ', inputArrBal)

            // console.log('a => ', summ)
            // console.log('b => ', ExpTot.value)
            // console.log('c => ', Deposits.value)

            let x = summ - parseFloat(ExpTot?.value || 0) - parseFloat(Deposits?.value || 0)
            // console.log('x value => ', x)
            setValue('moneyOnhand', x)
          }
        })
      }

      setFormSchemaIncome(inputArr)
      setFormSchemaBalance(inputArrBal)
    } else if (inputGroup == 'expenses') {
      let inputArr = cloneDeep(formSchemaExpenses || {})
      let inputArrIn = cloneDeep(formSchemaIncome || {})
      let inputArrBal = cloneDeep(formSchemaBalance || {})

      let summ = 0

      if (inputArr?.inputs?.length > 0) {
        inputArr.inputs.map((item) => {
          if (item.name == inputItem.name) {
            item.value = val
            summ += parseFloat(val)
          } else {
            if (item.name != 'total') {
              summ += parseFloat(item.value)
            }
          }

          if (item.name == 'total') {
            item.value = summ
          }
        })
      }

      if (inputArrBal.inputs.length > 0) {
        let incomTot = inputArrIn.inputs.find((item) => item.name == 'total')

        inputArrBal.inputs.map((item) => {
          if (item.name == 'total') {
            item.value = parseFloat(incomTot.value) - summ
          }
        })
      }

      setFormSchemaExpenses(inputArr)
      setFormSchemaBalance(inputArrBal)
    }
  }

  const onSubmit = (data) => {
    // console.log('data => ', data)

    // return false

    // console.log('period => ', period)

    let ssoBalanceVal = 0
    setErrorPeriod1(null)

    // console.log('isNotReportsProgress => ', isNotReportsProgress)
    // return false

    if (period == 1 || isNotReportsProgress == 1) {
      let ssoBalanceObj = formSchema?.period1Panel?.inputs?.find(
        (item) => item.name === 'ssoBalance'
      )
      let a = parseFloat(data?.ssoBalance || 0)
      let b = parseFloat(data?.withdrawAmt || 0)

      ssoBalanceVal = ssoBalanceObj?.value || 0

      if (a <= 0) {
        setErrorPeriod1(`กรุณาตรวจสอบ เงินรับจาก สสส. งวด นี้`)
        return false
      } else if (b > a) {
        setErrorPeriod1(`ยอดขอเบิกเงินงวดนี้ ต้องน้อยกว่าหรือเท่ากับ เงินรับจาก สสส. งวด นี้`)
        return false
      }
    } else {
      let ssoBalanceObj = formSchema?.income?.inputs?.find((item) => item?.name === 'ssoBalance')

      ssoBalanceVal = ssoBalanceObj?.value || 0
    }

    if (data?.ssoBalance > parseFloat(ssoBalanceVal)) {
      setErrorPeriod1(
        `ไม่สามารถบันทึก "เงินรับจาก สสส. งวด นี้" มากกว่างบประมาณที่ตั้งไว้ (${ssoBalanceVal} บาท)`
      )
      return false
    }

    // console.log('data.attachFiles => ', data.attachFiles[0].blobFile)

    const formData = new FormData()

    formData.append('ProjectVersionId', projectVersionId || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('Period', period || '')
    formData.append('InstallmentPlanDetailId', installmentPlanId || '')
    // formData.append('Id', projectActivitySchema?.withdrawInput?.id || '')
    formData.append('Id', financialReportIdVal || '')

    formData.append('BudgetCostAmt', data?.ssoBalance || 0)
    formData.append('TotalActivityCostAmt', finalTotalActivityVal || 0)
    formData.append('WithdrawForBankAccountAmt', data?.withdrawMoneyBankAccount || 0)
    formData.append('InterestAmt', data?.interestReceivable || 0)
    formData.append('BankAccountOpeningAmt', data?.bankAccOpeningMoney || 0)
    formData.append('BankAccountBalanceAmt', data?.bankDeposits || 0)
    formData.append('WithdrawAmt', data?.withdrawAmt || 0)
    formData.append('MoneyOnhand', data?.moneyOnhand || 0)
    // formData.append('AttachFiles', data.attachFiles[0].blobFile)

    data.attachFiles &&
      data.attachFiles?.forEach((element) => {
        formData.append('FinancialFile', element.blobFile)
      })

    handleSaveSummaryPeriodic(formData)
  }

  const handleSaveSummaryPeriodic = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await saveFinancialReport(request)
      // console.log('response => ', response)
      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        handleGetSchema()
        // statusOnSave(true)

        formSchema?.attachFiles?.name && setValue(formSchema?.attachFiles?.name, null)

        location.reload()
      } else {
        setIsError(true)
        // statusOnSave(false)
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || SAVE_FAILED_MSG,
      })
      // statusOnSave(false)

      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || DEFAULT_ERR_MSG)
      } else {
        setIsError(DEFAULT_ERR_MSG)
      }
      // setIsShowConfirm(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleGetSchema = async () => {
    startLoading()
    try {
      const _schema = await getFinancialReport(
        period,
        projectCode,
        projectVersionId,
        installmentPlanId
      )
      // console.log('reeeee => ', _schema.financialReportId)
      setFinancialReportIdVal(_schema.financialReportId)
      setFormSchema(_schema.forms.summaryPeriodicExpenses)
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
  }

  const handlePreviewFile = async (fileObj) => {
    // console.log('handlePreviewFile => ', fileObj)

    startLoading()
    var file = await getDowloadSubProjectFilePath(fileObj.path)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const handleDownloadFile = async (fileObj) => {
    // console.log('handleDownloadFile => ', fileObj)

    startLoading()
    var file = await getDowloadSubProjectFilePath(fileObj.path)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj?.name || 'สำเนาสมุดบัญชีเงินฝากธนาคาร')
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  return (
    <>
      {formSchema && (
        <Panel shaded header={formSchema.header} collapsible defaultExpanded>
          {formSchemaIncome && (
            <>
              <div>
                <h6 style={{ marginLeft: 80 }}>{formSchemaIncome.title}</h6>
                {formSchemaIncome.inputs &&
                  formSchemaIncome.inputs.map((item, index) => {
                    if (item.name == 'total') {
                      return rowTotal(item)
                    }

                    return rowInputForm(item, index, 'income')
                  })}
              </div>
            </>
          )}
          {/* {formSchema.income && (
            <>
              <div>
                <h6 style={{ marginLeft: 80 }}>{formSchema.income.title}</h6>
                {formSchema.income.inputs &&
                  formSchema.income.inputs.map((item, index) => {
                    if (item.name == 'total') {
                      return rowTotal(item)
                    }

                    return rowInputForm(item, index)
                  })}
              </div>
            </>
          )} */}
          {formSchemaExpenses && (
            <>
              <div style={{ marginTop: 20 }}>
                <h6 style={{ marginLeft: 80 }}>{formSchemaExpenses.title}</h6>
                {formSchemaExpenses.inputs &&
                  formSchemaExpenses.inputs.map((item, index) => {
                    if (item.name == 'total') {
                      return rowTotal(item)
                    }

                    return rowInputForm(item, index, 'expenses')
                  })}
              </div>
            </>
          )}
          {/* {formSchema.expenses && (
            <>
              <div style={{ marginTop: 20 }}>
                <h6 style={{ marginLeft: 80 }}>{formSchema.expenses.title}</h6>
                {formSchema.expenses.inputs &&
                  formSchema.expenses.inputs.map((item, index) => {
                    if (item.name == 'total') {
                      return rowTotal(item)
                    }

                    return rowInputForm(item, index)
                  })}
              </div>
            </>
          )} */}

          {formSchemaBalance && (
            <>
              <div style={{ marginTop: 20 }}>
                <h6 style={{ marginLeft: 80 }}>{formSchemaBalance.title}</h6>
                {formSchemaBalance.inputs &&
                  formSchemaBalance.inputs.map((item, index) => {
                    if (item.name == 'total') {
                      return rowTotal(item)
                    }

                    return rowInputForm(item, index, 'balance')
                  })}
              </div>
            </>
          )}
          {/* {formSchema.balance && (
            <>
              <div style={{ marginTop: 20 }}>
                <h6 style={{ marginLeft: 80 }}>{formSchema.balance.title}</h6>
                {formSchema.balance.inputs &&
                  formSchema.balance.inputs.map((item, index) => {
                    if (item.name == 'total') {
                      return rowTotal(item)
                    }

                    return rowInputForm(item, index)
                  })}
              </div>
            </>
          )} */}
          {formSchema.period1Panel && (
            <>
              <div style={{ marginTop: 20 }}>
                <h6 style={{ marginLeft: 80 }}>{formSchema.period1Panel.title}</h6>
                {formSchema.period1Panel.inputs &&
                  formSchema.period1Panel.inputs.map((item, index) => {
                    if (item.name == 'total') {
                      return rowTotal(item)
                    }

                    return rowInputForm(item, index)
                  })}
              </div>
            </>
          )}
          {formSchema.attachFiles && (
            <Row style={{ marginTop: 40 }}>
              <Col lg={2} md={2} sm={2} xs={2}></Col>
              <Col lg={20} md={20} sm={20} xs={20}>
                <ErrorMessage error={errors[formSchema.attachFiles.name]} />
                <ControlLabel
                  className={classNames(
                    isRequired(formSchema.attachFiles.validators) && 'required'
                  )}
                >
                  {formSchema.attachFiles.header}
                </ControlLabel>
                <Controller
                  key={formSchema.attachFiles.name}
                  name={formSchema.attachFiles.name}
                  control={control}
                  rules={isValidators(formSchema.attachFiles.validators)}
                  defaultValue={''}
                  render={(props) => {
                    return (
                      <Uploader
                        accept={formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'}
                        autoUpload={false}
                        disabled={formSchema.attachFiles.disabled}
                        fileListVisible={true}
                        listType="picture-text"
                        fileList={props.value || []}
                        onChange={(fileList) => {
                          // console.log('fileList xxx ', fileList)

                          if (isEmpty(fileList)) {
                            props.onChange(undefined)
                          } else {
                            let file = fileList[fileList.length - 1]

                            if (
                              file.blobFile.size >
                              (formSchema?.attachFiles?.fileSize || defaultMaxFileSize) *
                                1024 *
                                1024
                            ) {
                              notification.open('error', {
                                title: `ขนาดไฟล์เกิน ${
                                  formSchema.attachFiles.fileSize || defaultMaxFileSize
                                } MB`,
                                duration: 5000,
                              })
                              return
                            }

                            if (isImageOrPdf(file.blobFile.type)) {
                              let newArr = []
                              newArr.push(file)
                              console.log('new arr => ', newArr)
                              props.onChange(newArr)
                              setFileTypeError(false)
                            } else {
                              setFileTypeError(true)
                              notification.open('error', {
                                title:
                                  'ชนิดที่รองรับ ' + formSchema.attachFiles.fileType ||
                                  '.jpg, .jpeg, .png, .pdf',
                                duration: 5000,
                              })
                            }
                          }
                        }}
                        draggable
                      >
                        <div>
                          <div
                            style={{ lineHeight: '50px' }}
                            className={classNames('uploader', `${theme[0]}-background`)}
                          >
                            <Icon size="4x" icon="upload2" />
                            <small className="uploder__text">
                              <p
                                style={{ wordBreak: 'break-word' }}
                                dangerouslySetInnerHTML={{
                                  __html: `คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ : .jpg, .jpeg, .png, .pdf <b>ขนาดไม่เกิน 20 Mb</b>`,
                                }}
                              />
                            </small>
                          </div>
                        </div>
                      </Uploader>
                    )
                  }}
                />
              </Col>
              <Col lg={2} md={2} sm={2} xs={2}></Col>
            </Row>
          )}
          {formSchema?.attachFiles && (
            <Row style={{ marginTop: 20 }}>
              <Col lg={2} md={2} sm={2} xs={2}></Col>
              <Col lg={20} md={20} sm={20} xs={20}>
                <SubProjectViewFilesWidget
                  files={formSchema?.attachFiles?.values || []}
                  stringFilesIsNull={`...กรุณา${formSchema.attachFiles.header}...`}
                  buttonEye
                  buttonDownload
                  onPreviewFile={handlePreviewFile}
                  onDownloadFile={handleDownloadFile}
                  viewMode
                />
              </Col>
              <Col lg={2} md={2} sm={2} xs={2}></Col>
            </Row>
          )}
          {/* {console.log('disabled => ', disabled)} */}
          {errorPeriod1 && (
            <div style={{ marginTop: 10 }}>
              <Message type="error" description={errorPeriod1} />
            </div>
          )}
          {!formsDisabled && (
            <Row style={{ marginTop: 20 }}>
              <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <div style={{ paddingLeft: 40, paddingRight: 25 }}>
                  <SaveButton disabled={!disabled} onClick={handleSubmit(onSubmit)}>
                    บันทึก
                  </SaveButton>
                </div>
              </Col>
            </Row>
          )}
        </Panel>
      )}
    </>
  )
}
